// JSON-LD wordt alleen tijdens de prerender (SSG) uitgeschreven; postbuild
// verplaatst de scripts daarna naar <head>. Een inline <script> in de body is
// onder React 19 niet hydratie-stabiel (script-nodes worden niet geclaimd →
// #418 op landingspagina's). Crawlers lezen de statische HTML; op de client
// renderen we daarom bewust niets.
export default function JsonLd({ data }) {
  if (!window.__PRERENDER__) return null;
  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
}
